import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setDialogHandle } from "../../../actions/dialog";
import { ReactComponent as TickSVG } from "../../../assets/images/icon-TickSquare.svg";
import Styles from "../../../scss/orderHistory.module.scss";
import { useOrders } from "../../util/OrderContext";
import { IProcessedOrders } from "../constants";
import { OrderDialog } from "../OrderDialog/OrderDialog";
import { readyForCollectionTransform } from "../OrderDialog/tranforms";
import { OrderBaseButton } from "./OrderBaseButton";
import CheckIcon from '@material-ui/icons/Check';
import { IReduxAppState } from "../../../reducers";
import { ICollectionPoint } from "../../ordersSetting/Forms/CollectionPointEntity";


interface IMarkReadyButtonProps {
    orderList: IProcessedOrders[];
    collectionPoints: ICollectionPoint[];
    disabled?: boolean;
}
export function MarkReadyButton({
    orderList,
    collectionPoints,
    disabled
}: IMarkReadyButtonProps) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { setMessageOptions } = useOrders()!;
    const venueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    function onClick() {
        dispatch(setDialogHandle({
            Component: OrderDialog,
            ComponentProps: {
                orderList,
                venueId,
                refreshOrderList: () => setMessageOptions(true),
                transformFunction: readyForCollectionTransform,
                errorLabel: "markAllReadyError",
                transFormArgs: [collectionPoints]

            },
            isFormDialog: false,
            styles: { className: Styles.FinishAllDialog },
            dialogTitle: <div className={Styles.ActionMessages}>
                <TickSVG />
                <p>
                    {t(`order.dialog.collectionTitle`)}
                </p>
            </div>
        }))
    }
    return <OrderBaseButton
        onClick={onClick}
        disabled={disabled}
        buttonProps={{ startIcon: <CheckIcon /> }}
        label="orderHistory.modal.markAllReady" />
}